"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDateDimension = exports.getDateFormatter = exports.getFiscalYearStartMonth = exports.getMeasureFormatString = exports.getTimestampGranularity = exports.buildMeasureAccessor = exports.buildTimestampAccessor = exports.getMeasureFeature = exports.getTimestampFeature = exports.MEASURE_COLUMN_NAME = exports.TIMESTAMP_COLUMN_NAME = void 0;
var dateFormatter_1 = require("../formatting/dateFormatter");
var models_1 = require("../models");
var EffectiveDefinition_1 = require("../models/EffectiveDefinition");
exports.TIMESTAMP_COLUMN_NAME = 'timestamp';
exports.MEASURE_COLUMN_NAME = 'measure';
var getTimestampFeature = function (features) {
    return features.timestamp;
};
exports.getTimestampFeature = getTimestampFeature;
var getMeasureFeature = function (features) {
    return features.measure;
};
exports.getMeasureFeature = getMeasureFeature;
var buildTimestampAccessor = function (effectiveDefinition) {
    var timestamp = (0, exports.getTimestampFeature)(effectiveDefinition.features);
    return function (dataRow) { return dataRow[timestamp === null || timestamp === void 0 ? void 0 : timestamp.column]; };
};
exports.buildTimestampAccessor = buildTimestampAccessor;
var buildMeasureAccessor = function (effectiveDefinition) {
    var measure = (0, exports.getMeasureFeature)(effectiveDefinition.features);
    return function (dataRow) { return dataRow[measure.column]; };
};
exports.buildMeasureAccessor = buildMeasureAccessor;
var getTimestampGranularity = function (effectiveDefinition) {
    var _a, _b;
    var timestamp = (0, exports.getTimestampFeature)(effectiveDefinition.features);
    var column = (0, EffectiveDefinition_1.columnSchemaForRef)(effectiveDefinition, timestamp);
    // Phoenix needs to be backwards compatible with oldest supported version (2020.4 as of Feb '22),
    // which doesn't return a `type` for the ColumnSchema, so we are casting here rather than using
    // isDateTimeColumnSchema. Once the oldest supported version does use `type` (2021.1), this should
    // be modified to use isDateTimeColumnSchema instead.
    return (_b = (_a = column) === null || _a === void 0 ? void 0 : _a.dateGranularity) !== null && _b !== void 0 ? _b : models_1.DateGranularity.UNKNOWN;
};
exports.getTimestampGranularity = getTimestampGranularity;
var getMeasureFormatString = function (definition) {
    var _a;
    var measure = (0, exports.getMeasureFeature)(definition.features);
    var column = (0, EffectiveDefinition_1.columnSchemaForRef)(definition, measure);
    // Phoenix needs to be backwards compatible with oldest supported version (2020.4 as of Feb '22),
    // which doesn't return a `type` for the ColumnSchema, so we are casting here rather than using
    // isDateTimeColumnSchema. Once the oldest supported version does use `type` (2021.1), this should
    // be modified to use isDateTimeColumnSchema instead.
    return (_a = column) === null || _a === void 0 ? void 0 : _a.format;
};
exports.getMeasureFormatString = getMeasureFormatString;
var getFiscalYearStartMonth = function (definition) {
    var _a, _b;
    var timestamp = definition && (0, exports.getTimestampFeature)(definition.features);
    var column = definition && timestamp && (0, EffectiveDefinition_1.columnSchemaForRef)(definition, timestamp);
    // Phoenix needs to be backwards compatible with oldest supported version (2020.4 as of Feb '22),
    // which doesn't return a `type` for the ColumnSchema, so we are casting here rather than using
    // isDateTimeColumnSchema. Once the oldest supported version does use `type` (2021.1), this should
    // be modified to use isDateTimeColumnSchema instead.
    return (_b = (_a = column) === null || _a === void 0 ? void 0 : _a.fiscalYearStartMonth) !== null && _b !== void 0 ? _b : models_1.FiscalYearStartMonth.JANUARY;
};
exports.getFiscalYearStartMonth = getFiscalYearStartMonth;
var getDateFormatter = function (definition) {
    var granularity = definition ? (0, exports.getTimestampGranularity)(definition) : models_1.DateGranularity.UNKNOWN;
    var dateTrunc = (0, models_1.dateTruncFromGranularity)(granularity);
    var fiscalYearStartMonth = (0, exports.getFiscalYearStartMonth)(definition);
    return (0, dateFormatter_1.dateFormatterFactory)(dateTrunc, fiscalYearStartMonth);
};
exports.getDateFormatter = getDateFormatter;
var hasDateDimension = function (definition) {
    var _a;
    var timestampColumn = (_a = definition === null || definition === void 0 ? void 0 : definition.schema) === null || _a === void 0 ? void 0 : _a.timestamp;
    // casting instead of using `isDateTimeColumnSchema` to support Phoenix accessing a 2020.4 server
    return !!timestampColumn && !timestampColumn.isSnapshotTimestamp;
};
exports.hasDateDimension = hasDateDimension;
//# sourceMappingURL=metricValue.js.map